import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { environment } from '../environments/environment';
import { HeaderModule, FooterModule } from '@gsa-sam/layout';
import { AppRoutesModule } from './app.routes.module';
import { AppComponent } from './app.component';
import { SessionModule } from '@gsa-sam/shared';
import { ToastrModule } from "ngx-toastr";
import { NavigationModule } from "./navigation/navigation.module";
import { allIcons, IconModule, StackedIconModule } from "@gsa-sam/ngx-uswds-icons";
import { NgxBootstrapIconsModule } from 'ngx-bootstrap-icons';
import { SdsSubheaderModule } from "@gsa-sam/layouts";
import { SdsAutocompleteModule, SdsToastModule, SdsToastSettings } from '@gsa-sam/components';
import { ComponentsComponent } from './components/components.component';
import { AuthUserService } from './service/auth-user-service';
import { AuthInterceptorPage } from './auth-interceptor/auth-interceptor.component';
import { AuthInterceptorGuard } from './auth-interceptor/auth-interceptor.guard';
import { EmailSettingsGuard, FeedsGuard, LargeDownloadsGuard, NavigatedFor } from './t1-workspace/guards/navigation-check.guard';
import { APP_BASE_HREF } from '@angular/common';
import { AuthInterceptor } from './t1-workspace/interceptors/auth.interceptor';
import { UsernameHeaderModule } from './username-header/username-header.module';
import { ServiceUtils } from './service/service-globals';
import { AccountDetailsUpdateComponent } from './components/account-details/account-details-update/account-details-update.component';
import { SdsFormlyModule } from '@gsa-sam/sam-formly';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';
import { OTPModalComponent } from './components/account-details/otp-modal/otp-modal.component';
import { OrgDisplayNamePipe } from './pipes/fh-display-name/fh-display-name.pipe';
import { TitleStrategy } from '@angular/router';
import { TemplatePageTitleStrategy } from './service/title-strategy/title-strategy.service';
import { UnleashModule } from '@gsa-sam/shared';
// We are extracting a providers array here so it easier to add
// a provider conditionally
const conditionalProviders = [];

// We need to replace the 'workspace' route that comes from SFE
// with the 'workspace' route found in ADMIN MFE, we need to do
// this only for 155 environment and alpha 2
const isProdEnv = environment.production;
const hostname = window.location.hostname;
const isInAlpha2 = hostname.includes('155') || hostname.includes('alpha2');
if (isInAlpha2 && isProdEnv) {
  conditionalProviders.push({ provide: APP_BASE_HREF, useValue: '/' });
}

// Enable local environment login
if (!isProdEnv) {
  conditionalProviders.push({ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true });
}

@NgModule({
  declarations: [AppComponent, ComponentsComponent, AuthInterceptorPage, AccountDetailsUpdateComponent, OTPModalComponent],
  imports: [
    AppRoutesModule,
    BrowserAnimationsModule,
    BrowserModule,
    SdsToastModule,
    ToastrModule.forRoot(SdsToastSettings),
    HttpClientModule,
    HeaderModule.forRoot({
      environment: 'MFE-ADMIN',
      apiUrl: environment.API_UMBRELLA_URL,
      apiKey: environment.API_UMBRELLA_KEY,
      // showNewSamLogo: 'true',
    }),
    FooterModule.forRoot({
      environment: 'MFE-ADMIN',
      // showRegistrationStatusLink: 'true',
    }),
    SessionModule.forRoot({
      /// Use session default timeouts
      // idleSeconds: 10,
      // timeoutSeconds: 8,
      // keepaliveSeconds: 9,
      apiUrl: environment.API_UMBRELLA_URL,
      apiKey: environment.API_UMBRELLA_KEY,
      gatewayUrl: 'https://55samfrontendcomp.apps.prod-iae.bsp.gsa.gov',
      dataDog: {
        env: environment.DATA_DOG_ENV,
        service: 'MFE-ADMIN'
      }
    }),
    NavigationModule,
    IconModule,
    SdsSubheaderModule,
    NgxBootstrapIconsModule.pick(allIcons),
    UsernameHeaderModule,
    IconModule,
    StackedIconModule,
    SdsFormlyModule,
    FormsModule,
    ReactiveFormsModule,
    FormlyModule.forRoot(),
    SdsAutocompleteModule,
    UnleashModule.init({
      url: environment.UNLEASH_URL as string,
      clientKey: environment.UNLEASH_CLIENT_KEY,
      appName:  environment.UNLEASH_APP_NAME,
      disableRefresh: true, // to prevent unleash from polling and checking for updates
      disableMetrics: true //to prevent metrics from posting to unleash
    })
  ],
  providers: [
    AuthUserService,
    AuthInterceptorGuard,
    EmailSettingsGuard,
    LargeDownloadsGuard,
    FeedsGuard,
    NavigatedFor,
    ServiceUtils,
    ...conditionalProviders,
    OrgDisplayNamePipe,
    {provide: TitleStrategy, useClass: TemplatePageTitleStrategy}
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
